import type * as React from 'react';

function SvgSilksAu(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.1 17.88v-2.42c0-.64-.96-3.34-1.98-4.5-1.02-1.17 0-5.35 1.02-6.82.68-.98 1.94-1.9 3.79-2.75 2.18-.52 3.98-.52 5.4 0 2.12.77 2.92 3.73 2.92 4.48 0 .75 2.1 1.63 2.1 2.58 0 .64-.39 1.2-1.18 1.7 0 .56-.07 1.47-.2 2.74-.2 1.9-2.71 3.9-2.71 5v2.08c.62.44 1.77.85 3.45 1.25 2.53.6 4.61 1.48 5.53 1.95.91.48 7.06 11.94 7.06 14.4 0 2.45.83 6.64 0 8.66-.55 1.35-2.03 3.23-4.43 5.64 0 .96-.39 1.64-1.16 2.05-1.16.6-1.63 2.47-2.39 3.06-.76.59-1.64.98-2.34.98-.71 0-1.1-.98-2.27-1.57a2.68 2.68 0 01-1.46-1.9H20.14c-.68 0-1.22.37-1.62 1.1-.6 1.08-1.16 1-1.9 1.39-.75.39-1.3.7-2.1.98-.8.27-.94.86-1.54.97-.6.12-1.93-2.42-1.93-3.35 0-.61-1.04-1.37-3.13-2.28h-.96a22.34 22.34 0 01-4.24-5.24c-1.65-2.87-1.94-3.8-1.59-5.9.35-2.09 1.44-4.75 3.25-9.9 1.82-5.14 5.36-8.75 8.6-10.4 2.16-1.1 4.2-1.74 6.14-1.89l1.98-2.09zM9.15 41.76l2.62 7.94 3.54 1.8.64-4.97-4.18-7.62-2.62 2.85zm28-3.36l-1.53 4.18v7.9l1.52-.77c1.44-3.1 2.01-5.48 1.72-7.13a9.76 9.76 0 00-1.72-4.18z"
        fill="#DDD"
        fillRule="evenodd"
        stroke="#eeeff4"
      />
    </svg>
  );
}

export default SvgSilksAu;
